import { Component, ElementRef, forwardRef, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormsModule, } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { LyPalette } from '../core/palette';
export var /** @type {?} */ LY_UPLOAD_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return LyUploadFiles; }),
    multi: true
};
var LyUploadFiles = (function () {
    /**
     * @param {?} palette
     * @param {?} elementRef
     */
    function LyUploadFiles(palette, elementRef) {
        this.palette = palette;
        this.elementRef = elementRef;
        this.files = [];
        this._null = "data:image/png;base64,iVBORw0KG" + 'goAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAI' + "AAAUAAarVyFEAAAAASUVORK5CYII=";
    }
    /**
     * @param {?} val
     * @return {?}
     */
    LyUploadFiles.prototype.round = function (val) {
        return Math.round(val);
    };
    /**
     * @param {?} index
     * @return {?}
     */
    LyUploadFiles.prototype.removeFile = function (index) {
        this.files = this.files.filter(function (_, i) { return i !== index; });
        // console.log(index);
    };
    Object.defineProperty(LyUploadFiles.prototype, "_itemFileStyles", {
        /**
         * @return {?}
         */
        get: function () {
            return {
                color: this.palette.text.default,
            };
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    LyUploadFiles.prototype.ngOnChanges = function (changes) {
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    LyUploadFiles.prototype.changeInput = function ($event) {
        var _this = this;
        var /** @type {?} */ files = $event.target.files;
        var /** @type {?} */ fileName = $event.target.value.replace(/.*(\/|\\)/, '');
        var /** @type {?} */ fileReader = new FileReader();
        var /** @type {?} */ blank = "data:image/png;base64,iVBORw0KGgoAAAANSUhEU" + 'gAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAA' + "IAAAUAAarVyFEAAAAASUVORK5CYII=";
        console.log('length', $event.target.files.length);
        for (var /** @type {?} */ _i = 0; _i < $event.target.files.length; _i++) {
            console.log(_i);
            // fileReader.readAsDataURL($event.target.files[_i]);
            var /** @type {?} */ _fileReader = new FileReader();
            _fileReader.onload = function (ev) {
                // console.log('ev', ev);
                console.log('$event', $event, _i);
                // console.log(md5$($event.target.files[_i].type));
                if ($event.target.files[_i].type === 'image/jpeg' ||
                    $event.target.files[_i].type === 'image/jpg' ||
                    $event.target.files[_i].type === 'image/png' ||
                    $event.target.files[_i].type === 'image/gif') {
                    // console.log('is file IMAGE');
                    // this.imgDataUrl = ev.target.result;
                }
                else {
                    // console.log('not image');
                }
                var /** @type {?} */ color = 'abced235356';
                // let color = md5$($event.target.files[_i].type);
                _this.files.push({
                    file: $event.target.files[_i],
                    data: ev,
                    color: '#ff' + color.substr(0, 4),
                });
            };
            _fileReader.readAsDataURL($event.target.files[_i]);
            // console.log('_i', _i, $event.target.files[_i]);
        }
        // console.warn('this.files', this.files);
    };
    return LyUploadFiles;
}());
export { LyUploadFiles };
LyUploadFiles.decorators = [
    { type: Component, args: [{
                //.toString(),
                selector: 'ly-files-select',
                styles: [":host{display:block}._container-files{width:100%;position:relative;padding:16px 16px 32px 16px}._container-files ._total-file-size{position:absolute;bottom:0;left:0;font-size:14px}._container-files ._item-file{width:128px;height:128px;overflow:hidden;display:inline-block;position:relative;margin:8px;box-shadow:1px 1px 8px 1px rgba(0,0,0,0.42);border-radius:3px}._container-files ._item-file ._file-remove{position:absolute;top:0;right:0;z-index:1;background:rgba(255,255,255,0.96);width:24px;height:24px;line-height:24px;text-align:center;cursor:pointer}._container-files ._file-type{position:absolute;top:0;bottom:0;left:0;right:0;font-size:16px;text-align:center;padding:8px;opacity:.85}._container-files ._file-img{position:absolute;top:0;z-index:1;bottom:0;left:0;right:0;width:inherit;height:inherit}._container-files ._file-img img{width:inherit;height:inherit;background-size:cover;background-position:center}._container-files ._file-inf{position:absolute;font-size:13px;bottom:0;left:0;right:0;color:#fff;background-color:rgba(0,0,0,0.35);padding:8px;white-space:nowrap;z-index:2}._container-files ._file-inf ._file-name{overflow:hidden;text-overflow:ellipsis} "],
                template: "\n  <div class=\"_container-files\">\n    <div class=\"_item-file\" *ngFor=\"let file of files; let i = index\">\n      <div class=\"_file-inf\">\n        <div class=\"_file-name\">{{file.file.name}}</div>\n        <div class=\"_file-size\">{{round(file.file.size / 1024)}} Kb</div>\n      </div>\n      <div [style.background]=\"file.color\" class=\"_file-type\" [ngStyle]=\"_itemFileStyles\">\n        <div [class]=\"file.file.type\">{{file.file.type}}</div>\n      </div>\n      <div class=\"_file-img\">\n        <img *ngIf=\"file.file.type == 'image/jpeg' ||\n        file.file.type == 'image/jpg' ||\n        file.file.type == 'image/png' ||\n        file.file.type == 'image/gif'\"\n        [src]=\"_null\" class=\"_file-img\"\n        [style.background-image]=\"'url(' + file.data.target.result + ')'\" />\n      </div>\n      <div class=\"_file-remove\" (click)=\"removeFile(i)\">x</div>\n    </div>\n    <span class=\"_total-file-size\">{{ files.length }} Files Selected</span>\n  </div>\n  ",
                providers: [LY_UPLOAD_CONTROL_VALUE_ACCESSOR],
            },] },
];
/**
 * @nocollapse
 */
LyUploadFiles.ctorParameters = function () { return [
    { type: LyPalette, },
    { type: ElementRef, },
]; };
function LyUploadFiles_tsickle_Closure_declarations() {
    /** @type {?} */
    LyUploadFiles.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    LyUploadFiles.ctorParameters;
    /** @type {?} */
    LyUploadFiles.prototype.files;
    /** @type {?} */
    LyUploadFiles.prototype._null;
    /** @type {?} */
    LyUploadFiles.prototype.palette;
    /** @type {?} */
    LyUploadFiles.prototype.elementRef;
}
var LyUploadFilesModule = (function () {
    function LyUploadFilesModule() {
    }
    /**
     * @return {?}
     */
    LyUploadFilesModule.forRoot = function () {
        return {
            ngModule: LyUploadFilesModule,
            providers: []
        };
    };
    return LyUploadFilesModule;
}());
export { LyUploadFilesModule };
LyUploadFilesModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, FormsModule],
                exports: [LyUploadFiles],
                declarations: [LyUploadFiles],
            },] },
];
/**
 * @nocollapse
 */
LyUploadFilesModule.ctorParameters = function () { return []; };
function LyUploadFilesModule_tsickle_Closure_declarations() {
    /** @type {?} */
    LyUploadFilesModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    LyUploadFilesModule.ctorParameters;
}



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui-profile/upload-files/upload-files.js
// module id = 1366
// module chunks = 31